// StoreInformationForm.js
import React, { useEffect, useMemo, useState } from 'react';
import {
  AppBar,
  Toolbar,
  Box,
  Container,
  Typography,
  CardMedia,
  Paper,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  Button,
  Grid,
  Checkbox,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  FormGroup,
  Divider,
  CircularProgress,
  Alert,
  Dialog,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { toast } from 'react-toastify';
import Logo from '../assets/images/logo-form.png';
import Services from 'src/services/Services';
import Iconify from '../components/iconify';
import IMG1_URL from '../assets/images/Image_001.jpg'; // iOS QR
import IMG2_URL from '../assets/images/Image_002.jpg'; // Android QR
// görsel tablo eskiden kullanılanlar
import IMG3_URL from '../assets/images/Image_003.png';
import IMG4_URL from '../assets/images/Image_004.png';

async function toDataUrl(url) {
  const res = await fetch(url);
  const blob = await res.blob();
  return await new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

// HTML şablonu – formdaki “Firma Yetkilisi” bilgileri için yer tutucular eklendi.
// Değer yoksa boş bırakılır ve yalnızca etiketler görünür.
const AGREEMENT_TEMPLATE = `
<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="tr" lang="tr">
  <head>
    <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
    <title>Mall Logistics - Mağaza Sözleşmesi</title>
    <meta name="author" content="M. Fatih Savata" />
    <style type="text/css">
      * { margin: 0; padding: 0; text-indent: 0; }
      body { width: 800px; margin: auto; background:#ffffff; }

      h3 { color: black; font-family: Arial, sans-serif; font-weight: bold; font-size: 24px; text-align: center; margin-bottom: 15px; }
      h1 { color: black; font-family: Arial, sans-serif; font-weight: bold; font-size: 16.5pt; margin: 15px 0; }
      h2 { color: #fff; font-family: Arial, sans-serif; font-weight: bold; font-size: 13.5pt; }
      h4 { color: black; font-family: Arial, sans-serif; font-weight: bold; font-size: 11pt; }

      .p, p { color: black; font-family: Arial, sans-serif; font-size: 13pt; margin-bottom: 15px; line-height: 20px; text-align: justify; }
      .s1 { color: black; font-family: Arial, sans-serif; font-weight: bold; font-size: 10pt; }
      .s3 { color: black; font-family: Arial, sans-serif; font-weight: bold; font-size: 9pt; }
      .s8 { color: black; font-family: Arial, sans-serif; font-style: italic; font-weight: bold; font-size: 9.5pt; }
      .a, a { color: black; font-family: Arial, sans-serif; font-weight: bold; font-size: 16.5pt; text-decoration: none; }

      /* Fiyat tablosu */
      table { width: 100%; border-collapse: collapse; margin: 10px 0 20px; }
      thead th { background: #0F243E; color: #fff; font-family: Arial, sans-serif; font-weight: bold; font-size: 12pt; text-align: left; padding: 8px; }
      tbody td { padding: 8px; font-family: Arial, sans-serif; font-size: 12pt; }
      tbody tr:nth-child(odd) { background: #C5D9F0; }
      tbody tr:nth-child(even) { background: #FFFFFF; }
      tbody td:last-child { text-align: right; white-space: nowrap; }

      /* Üst alan düzeni */
      .top-wrap { position: relative; }
      .white-block { background:#ffffff; padding: 10px 12px; }
      /* SADECE firma kısmındaki hücreler beyaz olsun */
      .white-block td { background:#ffffff !important; }

      /* QR alanı */
      .qr-block { margin-top: 8px; text-align: right; }
      .qr-table { border-collapse: collapse; margin-left: auto; }
      /* SADECE QR hücreleri beyaz olsun */
      .qr-table td { text-align: center; padding: 0 14px; background:#ffffff !important; }
      .qr-title { font-family: Arial, sans-serif; font-weight: bold; font-size: 10pt; }
      .qr-img { width: 90px; height: auto; image-rendering: auto; }
    </style>
  </head>
  <body>

    <p><br /></p>
    <h3>SÖZLEŞME</h3>

    <p>{company_legal_title} ünvanlı firmanın (kısaca, FİRMA) <b>{mall_title}</b> Alışveriş Merkezi&#39;nde yer alan {company_title} markası adı altında faaliyet gösteren mağaza/şubesine ait ürünlerin, mal kabul
    alanından, depodan veya muhaberat ofisinden FİRMA’nın mağaza/şubesine, veya mağaza/şubesinden ürün kabul alanına, deposuna veya muhaberat ofisine yapılacak olan taşıma işlemlerinin yapılması için FİRMA, merkez adresi Balmumcu Mah. Gazi Umur Paşa Sok. Bimar Plaza Kat:4 D: 13, Beşiktaş- İstanbul olan AVM Lojistik Tic. A.Ş. ünvanlı şirketi (kısaca, MALL LOGISTICS) yetkilendirmeyi kabul etmiştir.</p>
    <p>Yapılacak her taşıma işlemi Mal Teslim Formu kullanılan operasyonlarda; MALL LOGISTICS tarafından mal teslim tutanağı ile kayıt altına alınacak, işbu Mal Teslim Tutanağının imzalı bir nüshası FİRMA&#39;da, imzalı bir diğer nüshası da MALL LOGISTICS’te kalacaktır.</p>
    <p>Yazılım kullanılan operasyonlarda ise; mağazanıza IT ekibimiz tarafından size özel üretilmiş statik QR kod imza karşılığı teslim edilecektir. Bu mağazanızın dijital mührü olacaktır. Teslim tesellüm işlemi statik QR okutularak gerçekleşecektir. Ayrıca Mall Logistics uygulamasını (App) indirerek statik QR yerine dinamik QR oluşturabilir, iş emri yaratabilir, gönderilerinizin anlık durumunu takip edebilir, diğer çalışma arkadaşlarınızın iş emirlerini görebilir ve Mall Logistics APP’in birçok özelliğinden faydalanabilirsiniz. MALL LOGISTICS ile yapılmış taşımalar ile alakalı dökümü, istendiği takdirde e-mail yoluyla FİRMA’ya ulaştırılabilir ya da FİRMA taşıma listesini uygulama içerisinden kullanıcı girişi yaparak sistemden çekebilir.</p>
    <p>Bu yöntemlerle kayıt altına alınan tüm ürünler, MALL LOGISTICS tarafından taşıma esnasında oluşabilecek herhangi bir hasara karşı sigorta kapsamına girmiş kabul edilir. Taşıma esnasında mal(lar)ın kısmen veya tamamen hasara uğraması veya zayi olması veya vb. hallerde, MALL LOGISTICS, FIRMA’ya malın CIF bedelini (Mal bedeli) ödemeyi taahhüt eder. Taşıması yapılmak suretiyle sigorta kapsamına girecek olan ürünlerin, taşıma öncesi MALL LOGISTICS personeli tarafından göz ile hasar kontrolü yapılır. Yırtık, delik, ezik, yıpranmış, orijinal paketi bozulmuş ve benzeri ürünler, ancak FİRMA’nın mağaza/şubesindeki bir yetkilisinin bilgisi ve onayı alındıktan sonra taşıma işlemi gerçekleştirilir. Mall Logistics’e imza karşılığı teslim edilmemiş ürünler için Mall Logistics sorumlu tutulmayacaktır.</p>
    <p>Bir aylık taşımaların tamamına karşılık gelen taşıma bedeli, aylık olarak FİRMA&#39;ya fatura edilecek olup; MALL LOGISTICS yapılmış taşımalar ile alakalı bir listeyi, istendiği takdirde e-mail yoluyla FİRMA’ya ulaştırılabilir. Faturaya konu bedelin tamamı, faturanın alındığı tarihten itibaren en geç 15 (onbeş) gün içerisinde ödenecek olup; bu kesin vade tarihinde ödenmeyen faturalara, ticari işlerde uygulanan temerrüt faizi oranında gecikme faizi ödenecektir.</p>
    <p>Taşımalara ilişkim biten ayın döküm listesi takip eden ayın 5’i ile 10’u arasında e-posta adresine gönderilecektir.</p>
    <p>FİRMA ile kesintisiz iletişim ve yazışmaların tam ve zamanında yapılabilmesi adına, FİRMA&#39;ya ait bilgiler aşağıdaki şekildedir;</p>

    <!-- ÜST BİLGİ BLOĞU – ARKAPLANI BEYAZ -->
    <div class="top-wrap">
      <table class="white-block" style="width:100%; border-collapse:collapse; margin: 10px 0 6px;">
        <tr>
          <!-- SOL: Firma etiketleri + değerleri -->
          <td style="vertical-align:top; width:55%;">
            <div>
              <div class="s1">Firma Yetkilisi</div>
              <div class="s1">Adı Soyadı : <span>{official_name}</span></div>
              <div class="s1">Görevi : <span>{official_role}</span></div>
              <div class="s1">Tel 1 : <span>{official_phone}</span></div>
              <div class="s1">Faks: <span>{official_fax}</span></div>
              <div class="s1">E-Posta: <span>{official_email}</span></div>
              <div class="s1">Ticari Ünvan : <span>{official_trade_title}</span></div>
              <div class="s1">Vergi Dairesi / Numarası : <span>{official_tax_office_no}</span></div>
              <div class="s1">Kaşe / İmza : <span>{official_stamp_sign}</span></div>
            </div>
          </td>
          <!-- SAĞ: Şirket adı (QR'lar bu bloğun DIŞINDA) -->
          <td style="vertical-align:top; width:45%; text-align:right;">
            <span class="s1">AVM LOJISTIK TİC. A.Ş.</span>
          </td>
        </tr>
      </table>

      <!-- QR BLOĞU – en sağda ve biraz aşağıda, beyaz blok dışında -->
      <div class="qr-block">
        <table class="qr-table">
          <tr>
            <td><span class="qr-title">Ios</span></td>
            <td><span class="qr-title">Android</span></td>
          </tr>
          <tr>
            <td style="padding-top:4px;">
              <img class="qr-img" alt="iOS QR" src="mall-logistics-magaza-sozlesmesi-2025-09-v2_files/Image_001.jpg" />
            </td>
            <td style="padding-top:4px;">
              <img class="qr-img" alt="Android QR" src="mall-logistics-magaza-sozlesmesi-2025-09-v2_files/Image_002.jpg" />
            </td>
          </tr>
        </table>
      </div>
    </div>

    <h1>{mall_title}</h1>

    <!-- DİNAMİK FİYAT TABLOSU -->
    <table>
      <thead>
        <tr>
          <th>Hizmet</th>
          <th>{year} Fiyat (TL)</th>
        </tr>
      </thead>
      <tbody>
        {price_rows}
      </tbody>
    </table>

    <p class="s8">*<u>Fiyatlara KDV dahil değildir.</u></p>

    <p><br /></p>
    <h1>OPERASYON TELEFON : 0537 727 20 62</h1>
    <p><br /></p>

    <p>
      <a href="mailto:operasyon@malllogistics.com" class="a" target="_blank">OPERASYON MAİL : </a>
      <a href="mailto:operasyon@malllogistics.com" target="_blank">operasyon@malllogistics.com</a>
    </p>
  </body>
</html>
`;

export default function StoreInformationForm() {
  const [token, setToken] = useState('');
  const [malls, setMalls] = useState([]);
  const [loadingMalls, setLoadingMalls] = useState(true);
  const [selectedMall, setSelectedMall] = useState(null);
  const [shop, setShop] = useState('');

  const [qrValue, setQrValue] = useState('');
  const [qrInput, setQrInput] = useState('');
  const [showForm, setShowForm] = useState(false);

  const [formData, setFormData] = useState({
    storeName: '',
    repFirstName: '',
    repLastName: '',
    repRole: '',
    repPhone: '',
    tradeTitle: '',
    taxNo: '',
    taxOffice: '',
    invoiceEmail: '',
  });

  const [email, setEmail] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [passwordRepeat, setPasswordRepeat] = useState('');

  const [kvkk, setKvkk] = useState(false);
  const [saving, setSaving] = useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [formDisabled, setFormDisabled] = useState(false);

  const currentYear = new Date().getFullYear();

  // KVKK alanının görünürlüğü: Ticari Ünvan + Vergi No + AVM seçimi dolu olmalı
  const isKvkkVisible =
    (formData.tradeTitle || '').trim() !== '' &&
    (formData.taxNo || '').trim() !== '' &&
    (shop || '').toString().trim() !== '';

  useEffect(() => {
    (async () => {
      try {
        const mallsRes = await Services.GetMallsWithoutToken();
        setMalls(mallsRes.data.result);
      } catch (err) {
        console.error('AVM alınamadı:', err);
        toast.error('AVM bilgileri alınamadı.');
      } finally {
        setLoadingMalls(false);
      }
    })();
  }, []);

  const handleMallChange = (e) => {
    const id = e.target.value;
    setShop(id);
    setSelectedMall(malls.find((m) => m.id === id) || null);
  };

  const handleQrChange = (e) => {
    setQrValue(e.target.value);
    setQrInput('');
    setShop('');
    setSelectedMall(null);
    setShowForm(false);
  };

  const resetAll = () => {
    setQrValue('');
    setQrInput('');
    setShop('');
    setSelectedMall(null);
    setShowForm(false);
    setKvkk(false);
    setFormDisabled(false);
    setFormData({
      storeName: '',
      repFirstName: '',
      repLastName: '',
      repRole: '',
      repPhone: '',
      tradeTitle: '',
      taxNo: '',
      taxOffice: '',
      invoiceEmail: '',
    });
    setEmail('');
    setIsValidEmail(false);
    setUsername('');
    setPassword('');
    setPasswordRepeat('');
  };

  const isButtonEnabled =
    qrValue === 'yes'
      ? qrInput.trim() !== ''
      : qrValue === 'no'
      ? shop !== ''
      : false;

  // escape
  const escapeHtml = (str = '') =>
    String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

  // normalize/eşleştirme
  function normalize(str = '') {
    return String(str)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }
  function getKey(t = {}) {
    if (t.id != null && t.id !== '') return String(t.id);
    const title = normalize(t.title || '');
    const price = String(t.price ?? '');
    const currency = String(t.currency ?? '');
    return `${title}|${price}|${currency}`;
  }
  function matchesAny(title = '', keys = []) {
    const n = normalize(title);
    return keys.some((k) => n.includes(normalize(k)));
  }
  function buildOrderedTools(tools = []) {
    const order = [
      { keys: ['standart', 'standard'] },
      { keys: ['küçük', 'kucuk', 'small'] },
      { keys: ['büyük', 'buyuk', 'large'] },
      { keys: ['askılı', 'askili', 'hanger'] },
      { keys: ['1 koli', 'koli', 'box'] },
      { keys: ['kargo', 'cargo'] },
      { keys: ['palet', 'pallet'] },
    ];
    const used = new Set();
    const rows = [];

    for (const { keys } of order) {
      const matches = (tools || []).filter(
        (t) => !used.has(getKey(t)) && matchesAny(t?.title || '', keys)
      );
      for (const t of matches) {
        used.add(getKey(t));
        rows.push({
          unit: t.title || '',
          price: `${t.price} ${t.currency || 'TL'}`,
          _raw: t,
        });
      }
    }
    for (const t of tools || []) {
      const key = getKey(t);
      if (!used.has(key)) {
        used.add(key);
        rows.push({
          unit: t.title || '',
          price: `${t.price} ${t.currency || 'TL'}`,
          _raw: t,
        });
      }
    }
    return rows;
  }

  const priceList = useMemo(() => {
    if (!selectedMall) return [];
    const tools = selectedMall.transportation_tool_with_price || [];
    return buildOrderedTools(tools).map(({ unit, price }) => ({ unit, price }));
  }, [selectedMall]);

  async function buildAgreementHtml() {
    if (!selectedMall) {
      toast.error('Önce AVM seçiniz.');
      return null;
    }

    // Görseller base64
    const [img1, img2, img3, img4] = await Promise.all([
      toDataUrl(IMG1_URL),
      toDataUrl(IMG2_URL),
      toDataUrl(IMG3_URL),
      toDataUrl(IMG4_URL),
    ]);

    const tools = selectedMall.transportation_tool_with_price || [];
    const ordered = buildOrderedTools(tools);
    const priceRowsHtml = ordered
      .map(
        (r) =>
          `<tr><td>${escapeHtml(r.unit)}</td><td>${escapeHtml(
            (r._raw?.price ?? '').toString()
          )} ${escapeHtml(r._raw?.currency || 'TL')}</td></tr>`
      )
      .join('');

    const officialName = [formData.repFirstName, formData.repLastName]
      .filter(Boolean)
      .join(' ')
      .trim();
    const officialRole = formData.repRole || '';
    const officialPhone = formData.repPhone || '';
    const officialFax = '';
    const officialEmail = email || '';
    const officialTradeTitle = formData.tradeTitle || '';
    const officialTaxOfficeNo = [formData.taxOffice, formData.taxNo]
      .filter(Boolean)
      .join(' / ');
    const officialStamp = '';

    let html = AGREEMENT_TEMPLATE;
    html = html.replaceAll(
      '{company_legal_title}',
      escapeHtml(formData.tradeTitle || '')
    );
    html = html.replaceAll(
      '{mall_title}',
      escapeHtml(selectedMall.title || '')
    );
    html = html.replaceAll(
      '{company_title}',
      escapeHtml(formData.storeName || '')
    );
    html = html.replaceAll('{year}', String(currentYear));
    html = html.replace('{price_rows}', priceRowsHtml);

    html = html.replaceAll('{official_name}', escapeHtml(officialName));
    html = html.replaceAll('{official_role}', escapeHtml(officialRole));
    html = html.replaceAll('{official_phone}', escapeHtml(officialPhone));
    html = html.replaceAll('{official_fax}', escapeHtml(officialFax));
    html = html.replaceAll('{official_email}', escapeHtml(officialEmail));
    html = html.replaceAll(
      '{official_trade_title}',
      escapeHtml(officialTradeTitle)
    );
    html = html.replaceAll(
      '{official_tax_office_no}',
      escapeHtml(officialTaxOfficeNo)
    );
    html = html.replaceAll('{official_stamp_sign}', escapeHtml(officialStamp));

    if (img1)
      html = html.replace(
        /mall-logistics-magaza-sozlesmesi-2025-09-v2_files\/Image_001\.jpg/g,
        img1
      );
    if (img2)
      html = html.replace(
        /mall-logistics-magaza-sozlesmesi-2025-09-v2_files\/Image_002\.jpg/g,
        img2
      );
    if (img3)
      html = html.replace(
        /mall-logistics-magaza-sozlesmesi-2025-09-v2_files\/Image_003\.png/g,
        img3
      );
    if (img4)
      html = html.replace(
        /mall-logistics-magaza-sozlesmesi-2025-09-v2_files\/Image_004\.png/g,
        img4
      );

    return html;
  }

  async function openAgreementInNewTab() {
    const html = await buildAgreementHtml();
    if (!html) return;
    const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank', 'noopener');
  }

  const handleKvkkToggle = async (e) => {
    const checked = e.target.checked;
    setKvkk(checked);
    if (!checked) return;
    if (!selectedMall?.title) {
      toast.error('Lütfen önce bir AVM seçiniz.');
      setKvkk(false);
      return;
    }
    await openAgreementInNewTab();
  };

  const handleSearchClick = async () => {
    if (!isButtonEnabled) return;
    if (qrValue === 'yes') {
      try {
        const { data } = await Services.GetBranchByQR(qrInput);
        if (data.status && data.result) {
          const b = data.result;
          setSelectedMall(malls.find((m) => m.id === b.mallID) || null);
          setShop(b.mallID);
          setFormData({
            storeName: b.title || '',
            repFirstName: '',
            repLastName: '',
            repRole: '',
            repPhone: '',
            tradeTitle: b.companyLegalTitle || '',
            taxNo: b.billing?.taxNo || '',
            taxOffice: b.billing?.taxAdministration || '',
            invoiceEmail: b.billing?.email || '',
          });
          setShowForm(true);
        } else {
          toast.error('Mağaza bulunamadı');
        }
      } catch {
        toast.error('Mağaza bulunamadı');
      }
    } else {
      setShowForm(true);
    }
  };

  const handleEmailChange = (e) => {
    const raw = e.target.value.trim().toLowerCase();
    const filtered = raw.replace(/[^a-z0-9@._-]/g, '');
    const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(filtered);
    setIsValidEmail(valid);
    setEmail(filtered);
  };

  const hasSpaceInPassword =
    password.includes(' ') || passwordRepeat.includes(' ');
  const passwordsMatch = password === passwordRepeat;

  const allFieldsFilled = () => {
    const f = formData;
    return (
      f.storeName.trim() &&
      f.repFirstName.trim() &&
      f.repLastName.trim() &&
      f.repRole.trim() &&
      f.repPhone.trim() &&
      f.tradeTitle.trim() &&
      f.taxNo.trim() &&
      f.taxOffice.trim() &&
      f.invoiceEmail.trim() &&
      email.trim() &&
      username.trim() &&
      password &&
      passwordRepeat
    );
  };

  const canSave =
    isButtonEnabled &&
    kvkk &&
    isValidEmail &&
    !hasSpaceInPassword &&
    passwordsMatch &&
    allFieldsFilled();

  const handleSave = async () => {
    if (!canSave) return;
    setSaving(true);
    try {
      let branchId;
      if (qrValue === 'no') {
        const branchData = {
          title: formData.storeName,
          mallID: shop,
          corporationID: '',
          type: 'corporational',
          companyLegalTitle: formData.tradeTitle,
          billing: {
            status: true,
            type: 'corporational',
            taxNo: formData.taxNo,
            taxAdministration: formData.taxOffice,
            address: '',
            region: '',
            city: '',
            country: 'Türkiye',
            email: formData.invoiceEmail,
          },
          companyCorporationalCode: '',
          isPrimary: false,
        };
        const branchRes = await Services.CreateBranch(branchData);
        if (!branchRes.data.status) throw new Error('Branch oluşturulamadı');
        branchId = branchRes.data.result;
      } else {
        const qrInfo = await Services.GetBranchByQR(qrInput);
        const existing = qrInfo.data.result;
        branchId = existing.branchID;
        const updateData = {
          branchID: branchId,
          title: formData.storeName,
          mallID: shop,
          corporationID: existing.corporationID,
          type: 'corporational',
          companyLegalTitle: formData.tradeTitle,
          billing: {
            status: true,
            type: 'corporational',
            taxNo: formData.taxNo,
            taxAdministration: formData.taxOffice,
            address: existing.billing.address || '',
            region: existing.billing.region || '',
            city: existing.billing.city || '',
            country: existing.billing.country || '',
            email: formData.invoiceEmail,
          },
          companyCorporationalCode: existing?.companyCorporationalCode || '',
          isPrimary: false,
        };
        const updRes = await Services.BranchUpdate(updateData);
        if (!updRes.data.status) throw new Error('Mağaza güncellenemedi');
      }

      const userData = {
        corporationID: '',
        companyPosition: formData.repRole,
        branchID: branchId,
        mallID: shop,
        email,
        phone: formData.repPhone,
        name: formData.repFirstName,
        lastname: formData.repLastName,
        password,
        username,
        type: 'corporational',
        isAdministrator: true,
        accountCategory: 'store',
        frontAuth: ['operations'],
        authLocations: { branch: [branchId] },
      };
      const userRes = await Services.CreateUserForBranch(userData);
      if (!userRes.data.status) throw new Error('Kullanıcı oluşturulamadı');
      const userId = userRes.data.result;

      if (qrValue === 'no') {
        const locData = {
          title: formData.storeName,
          mallID: shop,
          branchID: branchId,
          adminUserID: userId,
          type: 'store',
          corporationID: '',
          address: '',
        };
        const locRes = await Services.CreateLocationWithoutToken(locData);
        if (!locRes.data.status) throw new Error('Lokasyon oluşturulamadı');
      } else {
        const qrInfo = await Services.GetBranchByQR(qrInput);
        const existingLocId = qrInfo.data.result.locations[0].locationID;
        const updLocData = {
          locationID: existingLocId,
          title: formData.storeName,
          mallID: shop,
          branchID: branchId,
          adminUserID: userId,
          type: 'store',
          corporationID: '',
          address: '',
        };
        const locUpdRes = await Services.LocationUpdateWithoutToken(updLocData);
        if (!locUpdRes.data.status) throw new Error('Lokasyon güncellenemedi');
      }

      setFormDisabled(true);
      setSuccessModalOpen(true);
    } catch (err) {
      console.error(err);
      toast.error(err.message || 'Hata oluştu');
    } finally {
      setSaving(false);
    }
  };

  if (loadingMalls) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ bgcolor: '#f9f9f9', minHeight: '100vh' }}>
      <AppBar position="static" sx={{ bgcolor: 'white' }}>
        <Toolbar sx={{ px: 2 }}>
          <Box component="img" src={Logo} alt="Logo" sx={{ height: 60 }} />
        </Toolbar>
      </AppBar>

      <Container maxWidth="sm" sx={{ py: 2, mt: 2 }}>
        {!showForm && (
          <>
            <Typography variant="h5" gutterBottom>
              Mall Logistics Neler Yapar?
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              Alışveriş merkezinin ihtiyaçları doğrultusunda kurulan Mall
              Logistics ekibi ile alışveriş merkezi Ürün/Mal Kabul Alanında
              gelen tüm ürünlerin karşılanması, sayılarak teslim alınmasını ve
              mağazalara transferi gerçekleştirilir.
            </Typography>

            <Box
              sx={{
                position: 'relative',
                width: '100%',
                pt: '56.25%',
                borderRadius: 2,
                overflow: 'hidden',
                my: 2,
              }}
            >
              <CardMedia
                component="video"
                src="https://files.easypoint.com.tr/files/videolar_mp4_magaza/ml-tanitim_2025-07-25.mp4"
                controls
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                }}
              />
            </Box>

            <Paper elevation={3} sx={{ p: 2, borderRadius: 2 }}>
              <FormControl component="fieldset" fullWidth>
                <FormLabel component="legend" sx={{ fontSize: 14 }}>
                  QR kodunuz var mı?
                </FormLabel>
                <RadioGroup
                  row
                  value={qrValue}
                  onChange={handleQrChange}
                  name="qr"
                >
                  <FormControlLabel
                    value="yes"
                    control={<Radio />}
                    label="Evet, QR kodum var"
                    disabled={formDisabled}
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="Hayır, QR kodum yok"
                    disabled={formDisabled}
                  />
                </RadioGroup>
              </FormControl>

              {qrValue === 'yes' && (
                <TextField
                  fullWidth
                  placeholder="QR kodu giriniz"
                  variant="outlined"
                  value={qrInput}
                  onChange={(e) => setQrInput(e.target.value)}
                  sx={{ mt: 2 }}
                  disabled={formDisabled}
                />
              )}

              {qrValue === 'no' && (
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <InputLabel>AVM Adı *</InputLabel>
                  <Select
                    value={shop}
                    label="AVM Adı *"
                    onChange={handleMallChange}
                    disabled={formDisabled}
                  >
                    {malls.map((m) => (
                      <MenuItem key={m.id} value={m.id}>
                        {m.title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}

              <Button
                variant="contained"
                fullWidth
                disabled={!isButtonEnabled || formDisabled}
                onClick={handleSearchClick}
                sx={{
                  mt: 2,
                  bgcolor:
                    isButtonEnabled && !formDisabled ? '#1B71F2' : '#D9D9D9',
                  '&:hover': {
                    bgcolor:
                      isButtonEnabled && !formDisabled ? '#155a9c' : undefined,
                  },
                }}
              >
                Ara
              </Button>
            </Paper>
          </>
        )}

        {showForm && selectedMall && (
          <>
            <Divider sx={{ my: 3, bgcolor: '#D9D9D9' }} />
            <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
              <Typography variant="subtitle1" gutterBottom>
                Mağaza Bilgi Formu
              </Typography>

              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="caption" color="text.secondary">
                    Mağaza Bilgileri
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel>AVM Adı *</InputLabel>
                    <Select disabled value={shop} label="AVM Adı *">
                      {malls.map((m) => (
                        <MenuItem key={m.id} value={m.id}>
                          {m.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Mağaza Adı"
                    value={formData.storeName}
                    onChange={(e) =>
                      setFormData((f) => ({ ...f, storeName: e.target.value }))
                    }
                    disabled={formDisabled}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="caption" color="text.secondary">
                    Mağaza Görevlisi
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Adı"
                    value={formData.repFirstName}
                    onChange={(e) =>
                      setFormData((f) => ({
                        ...f,
                        repFirstName: e.target.value,
                      }))
                    }
                    disabled={formDisabled}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Soyadı"
                    value={formData.repLastName}
                    onChange={(e) =>
                      setFormData((f) => ({
                        ...f,
                        repLastName: e.target.value,
                      }))
                    }
                    disabled={formDisabled}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Görevi"
                    value={formData.repRole}
                    onChange={(e) =>
                      setFormData((f) => ({ ...f, repRole: e.target.value }))
                    }
                    disabled={formDisabled}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Telefon No"
                    value={formData.repPhone}
                    onChange={(e) =>
                      setFormData((f) => ({ ...f, repPhone: e.target.value }))
                    }
                    disabled={formDisabled}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="E-posta"
                    type="email"
                    value={email}
                    onChange={handleEmailChange}
                    error={email.length > 0 && !isValidEmail}
                    helperText={
                      email.length > 0 && !isValidEmail
                        ? 'Geçerli bir e-posta giriniz.'
                        : ''
                    }
                    disabled={formDisabled}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Kullanıcı Adı"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    disabled={formDisabled}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Parola"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={formDisabled}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Parola Tekrar"
                    type="password"
                    value={passwordRepeat}
                    onChange={(e) => setPasswordRepeat(e.target.value)}
                    disabled={formDisabled}
                  />
                </Grid>
                {password.includes(' ') || passwordRepeat.includes(' ') ? (
                  <Grid item xs={12}>
                    <Alert severity="error">Şifre boşluk içeremez!</Alert>
                  </Grid>
                ) : password &&
                  passwordRepeat &&
                  password !== passwordRepeat ? (
                  <Grid item xs={12}>
                    <Alert severity="error">Şifreler eşleşmiyor!</Alert>
                  </Grid>
                ) : null}

                <Grid item xs={12}>
                  <Typography variant="caption" color="text.secondary">
                    Ticari Bilgiler
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Ticari Ünvan *"
                    value={formData.tradeTitle}
                    onChange={(e) =>
                      setFormData((f) => ({ ...f, tradeTitle: e.target.value }))
                    }
                    disabled={formDisabled}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Vergi No *"
                    value={formData.taxNo}
                    onChange={(e) =>
                      setFormData((f) => ({ ...f, taxNo: e.target.value }))
                    }
                    disabled={formDisabled}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Vergi Dairesi"
                    value={formData.taxOffice}
                    onChange={(e) =>
                      setFormData((f) => ({ ...f, taxOffice: e.target.value }))
                    }
                    disabled={formDisabled}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Fatura E-mail Adresi"
                    value={formData.invoiceEmail}
                    onChange={(e) =>
                      setFormData((f) => ({
                        ...f,
                        invoiceEmail: e.target.value,
                      }))
                    }
                    disabled={formDisabled}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="caption" color="text.secondary">
                    Fiyat Listesi
                  </Typography>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ bgcolor: '#0F243E', color: 'white' }}>
                          Araç / Birim
                        </TableCell>
                        <TableCell sx={{ bgcolor: '#0F243E', color: 'white' }}>
                          {currentYear} Fiyat
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {priceList.map((row, idx) => (
                        <TableRow
                          key={`${row.unit}-${idx}`}
                          sx={{
                            backgroundColor:
                              idx % 2 === 0 ? '#C5D9F0' : '#FFFFFF',
                          }}
                        >
                          <TableCell>{row.unit}</TableCell>
                          <TableCell
                            sx={{ textAlign: 'right', whiteSpace: 'nowrap' }}
                          >
                            {row.price}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Grid>

                {isKvkkVisible && (
                  <Grid item xs={12}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={kvkk}
                            onChange={handleKvkkToggle}
                            disabled={formDisabled}
                          />
                        }
                        label="KVKK bilgilerini okudum ve onaylıyorum.*"
                      />
                    </FormGroup>
                  </Grid>
                )}

                {!formDisabled && (
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="contained"
                      disabled={
                        !(
                          isButtonEnabled &&
                          kvkk &&
                          isValidEmail &&
                          !hasSpaceInPassword &&
                          passwordsMatch &&
                          allFieldsFilled()
                        ) || saving
                      }
                      onClick={handleSave}
                      sx={{
                        mt: 2,
                        bgcolor: '#1B71F2',
                        '&:hover': { bgcolor: '#155a9c' },
                      }}
                    >
                      {saving
                        ? 'İşleniyor…'
                        : qrValue === 'yes'
                        ? 'Güncelle'
                        : 'Kaydet'}
                    </Button>
                    <Button
                      fullWidth
                      variant="outlined"
                      onClick={resetAll}
                      disabled={saving}
                      sx={{
                        mt: 1,
                        borderColor: '#D9D9D9',
                        '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' },
                      }}
                    >
                      Geri
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Paper>
          </>
        )}

        <Dialog
          open={successModalOpen}
          onClose={() => setSuccessModalOpen(false)}
          PaperProps={{ sx: { textAlign: 'center', p: 3 } }}
        >
          <DialogContent>
            <Iconify
              icon="eva:checkmark-circle-2-fill"
              width={80}
              height={80}
              color="#4caf50"
            />
            <Typography variant="h6" sx={{ mt: 2 }}>
              {qrValue === 'yes'
                ? 'Güncelleme başarılı'
                : 'Bilgiler kaydedilmiştir'}
            </Typography>
          </DialogContent>
          <DialogActions sx={{ justifyContent: 'center' }}>
            <Button onClick={() => setSuccessModalOpen(false)}>Kapat</Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Box>
  );
}
